import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { useApi } from '../hooks'
import {
  Asset,
  AssetCreateInput,
  AssetInput,
  AssetQuery,
  PaginationOutput,
  PaginationQuery
} from '../types'

const api = useApi('/v2')

export async function getAssets(
  query: AssetQuery = {},
  config: AxiosRequestConfig = {}
): Promise<Asset[]> {
  const response = await api.get('/assets', {
    ...config,
    params: query
  })

  return response.data
}

export async function getAsset(id: string, config: AxiosRequestConfig = {}): Promise<Asset> {
  const response = await api.get(`/assets/${id}`, {
    ...config
  })

  return response.data
}

export async function createAsset(
  input: AssetCreateInput,
  config: AxiosRequestConfig = {}
): Promise<Asset> {
  const response: AxiosResponse<Asset> = await api.post('/assets', input, config)

  return response.data
}

export async function updateAsset(
  id: string,
  input: AssetInput,
  config: AxiosRequestConfig = {}
): Promise<Asset> {
  const response = await api.patch(`/assets/${id}`, input, {
    ...config
  })

  return response.data
}

/**
 * Delete the asset.
 */
export async function deleteAsset(id: string, config: AxiosRequestConfig = {}): Promise<Asset> {
  const response = await api.delete(`/assets/${id}`, {
    ...config
  })

  return response.data
}

export async function uploadAssetPhoto(
  id: string,
  photo: File,
  { headers, ...config }: AxiosRequestConfig = {}
): Promise<Asset> {
  const formData = new FormData()

  formData.append('file', photo)

  const response = await api.patch(`/assets/${id}/photo`, formData, {
    ...config,
    headers: {
      ...headers,
      'Content-Type': 'multipart/form-data'
    }
  })

  return response.data
}

export async function deleteAssetPhoto(
  id: string,
  config: AxiosRequestConfig = {}
): Promise<Asset> {
  const response = await api.delete(`/assets/${id}/photo`, {
    ...config
  })

  return response.data
}

export async function reattachAsset(id: string, config: AxiosRequestConfig = {}): Promise<Asset> {
  const response = await api.patch(
    `/assets/${id}/reattach`,
    {},
    {
      ...config
    }
  )

  return response.data
}

export async function getAssetsUsingPagination(
  query: AssetQuery = {},
  pagination: PaginationQuery,
  config: AxiosRequestConfig = {}
): Promise<PaginationOutput<Asset>> {
  const response = await api.get('/assets', {
    ...config,
    params: {
      ...query,
      ...pagination
    }
  })

  const page = parseInt(response.headers['x-page'])
  const pageSize = parseInt(response.headers['x-page-size'])
  const pageCount = parseInt(response.headers['x-page-count'])
  const totalCount = parseInt(response.headers['x-total-count'])

  return {
    page,
    pageSize,
    pageCount,
    totalCount,
    data: response.data
  }
}
